
export default [
    {
        url: '/pat/getstudylist',
        type: 'post',
        response: params => {
          const { pageno,pagesize} = params.body
          return {
            "code": 1,
            "info": "ok",
            "pageno": parseInt(pageno),
            "pagesize": parseInt(pageno),
            "totalcount":  20,
            "list": [
              {
                "age": "73",
                "applydatetime": "2020-04-29 22:47:40",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "57279",
                "patientidentity": "4428464744042496000",
                "patientname": "cao yin shen M/68",
                "reportdocname": "Davi",
                "reportidentity": "6295665673578119168",
                "score": "100",
                "states": "未报告",
                "studydate": "2015-01-09 16:15:32",
                "studyid": "1",
                "studyidentity": "1747794797210271744",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588149830.698143",
                "studyparts": "颈部",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 05:00:40"
              },
              {
                "age": "65",
                "applydatetime": "2020-04-29 22:33:54",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "54724",
                "patientidentity": "7029321967140438016",
                "patientname": "jiao tian cheng M/60",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "未审核",
                "studydate": "2014-10-29 10:04:28",
                "studyid": "1",
                "studyidentity": "1715370628955078656",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588149780.693356",
                "studyparts": "颈部",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:10:40"
              },
              {
                "age": "38",
                "applydatetime": "2020-04-29 20:21:05",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "MR31256",
                "patientidentity": "1756058984847933440",
                "patientname": "li yu liang M/36",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "待发布",
                "studydate": "2018-03-09 14:51:06",
                "studyid": "1",
                "studyidentity": "1756073603222110208",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588108881.629513",
                "studyparts": "",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:15:40"
              },
              {
                "age": "64",
                "applydatetime": "2020-04-29 17:54:34",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "MR19634",
                "patientidentity": "1776334941873668096",
                "patientname": "song yu liang M/61",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "已审核",
                "studydate": "2017-05-16 10:54:59",
                "studyid": "1",
                "studyidentity": "1776352949643935744",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1588108218.573683",
                "studyparts": "",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:20:45"
              },
              {
                "age": "66",
                "applydatetime": "2020-04-26 15:18:50",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "53688",
                "patientidentity": "670194943322390528",
                "patientname": "wang xue mei F/61",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "未报告",
                "studydate": "2014-10-01 11:09:58",
                "studyid": "1",
                "studyidentity": "670200258877095936",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1587885200.420357",
                "studyparts": "",
                "studystate": "普通",
                "uploaddocname": "",
                "timeout":"16",
                "checktimeout":"8",
                "uploadtime": "2020-06-16 11:25:45"
              },
              {
                "age": "87",
                "applydatetime": "2020-04-26 15:18:27",
                "checkdocname": "",
                "hasedit": "1",
                "hasreport": "0",
                "hospitalname": "医院2",
                "modality": "MR",
                "patientid": "53685",
                "patientidentity": "575998342945734656",
                "patientname": "you gen ding M/82",
                "reportdocname": "",
                "reportidentity": "",
                "score": "",
                "states": "未报告",
                "studydate": "2014-10-01 10:26:42",
                "studyid": "1",
                "studyidentity": "576003440073670656",
                "studyinstanceuid": "1.2.276.0.7230010.3.1.2.2831155776.1.1587885200.420291",
                "studyparts": "",
                "studystate": "普通",
                "timeout":"16",
                "checktimeout":"8",
                "uploaddocname": "",
                "uploadtime": "2020-06-16 11:30:15"
              }
            ],
            "main": null,
            "command": "",
            "data": null
          }
        }
      },
]